import { fromJS, Map } from "immutable"
import { returnStateIfNoAction } from "../helpers"
import requestStatus from '../../constants/requestStatus'
import actionTypes from "../../actions/actionTypes"

const getInitState = () =>{
    return fromJS({
        status: requestStatus.INITIALIZED,
        error: null,
        sortPerformances: null,
        attributeColorSettings: null,
        dateSettings: null,
        previewMovieHeadtext: ''
    })
}

const onUpdateSuccess = (state, action) => {
    const { generalSettings } = action.payload

    return fromJS({
        ... generalSettings
    })
}

const setPreviewMovieHeadtext = (state, action) => {
    const {text} = action.payload

    return state.setIn(['previewMovieHeadtext'], text)
}

const setCustomDateSettings = (state, action) => {
    const {dateObj} = action.payload

    return state.setIn(['dateSettings'], dateObj)
}

const updateAttributeSettings = (state, action) => {
    const {payload} = action.payload

    return state.setIn(['attributeColorSettings'], payload)
}

const onGet = (state, action) =>  state.set('status', requestStatus.REQUEST_PENDING)
                                        .set('error', '')

const onGetSuccess = (state, action) => {
    const {generalSettings } = action.payload

    delete generalSettings.status
    delete generalSettings.error

    return fromJS({
        status: requestStatus.REQUEST_SUCCESS,
        error: '',
        ... generalSettings
    })
}

const generalSettingsReducer = (state = getInitState(), action) => {
    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.PRINT_DATA_GET_REQUEST:
            return onGet(state);
        case actionTypes.PRINT_DATA_GET_SUCCESS:
            return onGetSuccess(state, action);
        case actionTypes.PRINT_DATA_UPDATE_SUCCESS:
            return onUpdateSuccess(state, action);
        case actionTypes.PRINT_DATA_GENERAL_UPDATE:
            return updateAttributeSettings(state, action);
        case actionTypes.PRINT_TOOL_SET_DATE_SETTINGS:
            return setCustomDateSettings(state, action);
        case actionTypes.PRINT_TOOL_PREVIEW_MOVIE_HEADTEXT:
            return setPreviewMovieHeadtext(state, action);
        default:
            return state;
    }

}

export default generalSettingsReducer